import { render, staticRenderFns } from "./openGrid.vue?vue&type=template&id=36f30b8e&scoped=true&"
import script from "./openGrid.vue?vue&type=script&lang=js&"
export * from "./openGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f30b8e",
  null
  
)

export default component.exports